import requestv2 from "~/utils/http-v2";

const trainingScheduleApi = {
	gets: async (params) => {
		const url = 'v2/training-schedule';
		return await requestv2.get(url, {params});
	},
	week: async () => {
		const now       = new Date();
		const dayOfWeek = now.getDay() === 0 ? 7 : now.getDay();
		const monday    = new Date(now);
		monday.setDate(now.getDate() - dayOfWeek + 1);
		monday.setHours(0, 0, 0, 0);
		const sunday = new Date(monday);
		sunday.setDate(monday.getDate() + 6);
		sunday.setHours(23, 59, 59, 999);
		const url = 'v2/training-schedule';
		return await requestv2.get(url, {
			params: {
				startFrom: Math.floor(monday.getTime() / 1000),
				startTo:   Math.floor(sunday.getTime() / 1000),
				limit:     50,
			}
		});
	},
	add: async (params) => {
		const url = 'v2/training-schedule';
		return await requestv2.post(url, params);
	},
	update: async (params) => {
		const url = `v2/training-schedule/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete: async (id) => {
		const url = `v2/training-schedule/${id}`;
		return await requestv2.delete(url);
	},
	status: async (params) => {
		const url = `v2/training-schedule/status/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default trainingScheduleApi;
